import { useMemo } from 'react';

export const useDeliveryPricing = ({
  isTakeAway,
  bill,
  productCategories,
  deliveryRestaurant,
  tipsAmount,
}) => {
  if (!productCategories || !bill || !deliveryRestaurant) {
    return {
      total: 0,
      subtotal: 0,
      totalDiscount: 0,
      totalPackagingPrice: 0,
      totalDeliveryPrice: 0,
      totalReachMinimalPrice: 0,
    };
  }

  const subtotal = (bill || {}).subtotal || 0;
  const totalDiscount = (bill || {}).discount || 0;

  const totalPackagingPrice = useMemo(() => {
    let combinedTemp = 0;
    if (
      !bill.cart ||
      bill.cart.length === 0 ||
      !productCategories ||
      productCategories.length === 0
    ) {
      return combinedTemp;
    }

    bill.cart.forEach((cartItem) => {
      productCategories.forEach((category) => {
        if (!category.products || category.products.length === 0) {
          return;
        }

        category.products.forEach((product) => {
          if (product.id === cartItem.productId) {
            combinedTemp += (product.packagingPrice || 0) * cartItem.quantity;
          }
        });
      });
    });

    return combinedTemp;
  }, [productCategories, bill]);

  const totalDeliveryPrice = isTakeAway ? 0 : deliveryRestaurant.deliveryPrice || 0;
  let totalReachMinimalPrice = 0;

  if (isTakeAway) {
    totalReachMinimalPrice =
      deliveryRestaurant.minTakeawayOrder > subtotal
        ? (deliveryRestaurant.minTakeawayOrder || 0) - subtotal
        : 0;
  } else {
    totalReachMinimalPrice =
      deliveryRestaurant.minDeliveryOrder > subtotal
        ? (deliveryRestaurant.minDeliveryOrder || 0) - subtotal
        : 0;
  }

  const total =
    subtotal +
    (tipsAmount || 0) -
    totalDiscount +
    totalDeliveryPrice +
    totalReachMinimalPrice +
    totalPackagingPrice;

  return {
    total,
    subtotal,
    totalDiscount,
    totalPackagingPrice,
    totalDeliveryPrice,
    totalReachMinimalPrice,
  };
};
